export const ACTIONS = {
  "audit.module.access": "Permiso para acceder al módulo de auditoría",

  "modify.coverage": "Modificar o Eliminar Cubrimiento",
  "create.coverage": "Crear Cubrimiento",

  "modify.news": "Modificar o eliminar cualquier tipo de novedad",

  "delete.aid": "Eliminar Auxilio",
  "create.aid": "Crear Auxilios",

  "modify.additionals": "Modificar o Eliminar Info. Adicional",
  "create.additional": "Registrar y/o modificar Adicional",

  "delete.workshift.scheduling": "Eliminar Programación",
  "create.workshift.scheduling": "Crear Programación",
  "create.exceptional": "Crear Programación Excepcional",

  "create.interruption": "Crear Interrupción",
  "modify.interruption": "Actualización Interrupción",
  "daily.attendance": "Planilla De Asistencia Diaria",

  "search.scheduling": "Consultar Programación",
  "modify.workshift.scheduling.before.time":
    "Modificar Programación Después Del Periodo",

  "management.scheduling": "Validación de Novedades",
  "approved.scheduling": "Aprobar Cambios de Turno",

  "associate.markings": "Crear Marcaciones",
  "assign.availability": "Asignar disponibilidad",

  "approve.covers": "Aprobar cubrimientos",
  "approve.interruptions": "Aprobar solicitudes de permisos",

  "assign.bonus": "Asignar bonificaciones a empleados manual",
  "remove.bonus": "Eliminar bonificaciones asignadas a empleados",

  "assingSchedule.operationCenter": "Asignar Centro de operación",
  "deleteSchedule.operationCenter": "Eliminar Centro de operación",
  "validate.compensated.shifts": "Validar Turnos Compensados",
  AllowValidatingTheUsualSundayWorkShiftSchedules:
    "Validar dominicales habituales",
  "change.event.types": "Cambiar tipos de eventos",

  "approve-payroll-novelty-flows": "Aprobador de horas extras",
  "setting-up-overtime-approval-flows":
    "Configuración de flujo de aprobación de horas extras",

  ProgrammedVsWorkedOvertimeModule:
    "Módulo horas extras programadas vs extras trabajadas",

  reports: {
    WorkshiftSchedulingReports: "Informes Programador",
    lateArrivalsEarlyDepartures: "Entradas tardes y salidas temprano calculado",
    lateArrivalsEarlyDeparturesGroup: "Entradas tardes y salidas temprano",
    AbsenceInterruption: "Ausencia e interrupción",
    InterruptionDetail: "Detalle interrupción",
    TimesInterruptions: "Tiempos e interrupciones",
    AdditionalHoursInterruptions: "Horas adicionales e interrupciones",
    EventsReport: "Reporte Eventos",
    PermanenceReport: "Reporte de permanencia",
    DailyAttendanceSheetReport: "Reporte Planilla de asistencia diaria",
    WorkShiftScheduling: "Programación de turnos",
    LunchTimeControl: "Control de tiempo de almuerzo",
    TimeWorked: "Tiempo Laborado",
    TotalHoursWorked: "Total horas trabajadas",
    ScheduledShiftsWithoutDialing: "Turnos programados sin marcaciones",
    DialingWithoutScheduledShift: "Marcaciones sin turno programado",
    ConsolidatedNumberPeoplePerWorkshift:
      "Consolidado Cantidad de Personas por Turno",
    RequestHistoryReport: "Reporte historial de solicitudes",
    IncompleteEvents: "Reporte de marcaciones incompletas",
    EmployeesWithoutWorkshiftSchedulings: "Reporte Personal sin Programación",
    WorkshiftAndInterruptionSchedulingAuditReport:
      "Reporte de Auditoría de Programación de Turnos e Interrupciones",
    DetailedProgrammingEventsReport:
      "Reporte detallado de programación y eventos",
    DettlementHoursScheduling: "Reporte Horas Liquidadas por Programación",
    BusinessUnitScheduling: "Reporte Programación de Unidades de Negocio",
    OvertimeApprovalAuditReport:
      "Reporte de Auditoría de aprobación horas extras",
    BonusLiquidationsReport: "Reporte de Liquidación de bonificaciones",
    LiquidationByTypeHoursByEmployeeReport:
      "Reporte de liquidacion de horas por empleado",
    LiquidationByTypeHoursFlatByEmployeeReport:
      "Reporte de labor desglosado por empleado",
  },
};
